module.exports = "../dist/img/img_1-21.33f4.jpg";